export default __webpack_public_path__ + "static/media/NoJobsFound.c174c126.svg";